"use strict";

exports.__esModule = true;
var methods = ['log', 'debug', 'info', 'warn', 'error', 'table', 'clear', 'time', 'timeEnd', 'count', 'assert'];
exports["default"] = methods;